import { useCallback } from 'react';

import useCountries from '@api/hooks/useCountries';
import constants, { defaultCountry } from '../../constants';

const useChangeCountry = ({
  setCountry,
  loginType,
  setMobileNumber,
  setNumberStepErrorMsg
}) => {
  const allCountries = useCountries();

  return useCallback(
    (countryOption) => {
      const countryToSwitchTo = (allCountries || [defaultCountry]).find(
        (countryFromList) => countryFromList.code === countryOption.value
      );
      setCountry(countryToSwitchTo);
      // reset mobile number and error msg on change of country
      if (loginType === constants.LOGIN_TYPE_NUMBER) {
        setMobileNumber('');
        setNumberStepErrorMsg('');
      }
    },
    [
      setCountry,
      loginType,
      setMobileNumber,
      setNumberStepErrorMsg,
      allCountries
    ]
  );
};

export default useChangeCountry;
